import { List, Map as ImmutableMap } from 'immutable';

// @ts-expect-error Untyped module
import RevenueAttributionCard from 'attribution-lib/components/revenueAttribution/ContentRevenueAttributionCard';
import { useContentObjectType, useAuthInfoProvider } from 'content-management-data-lib';
import { useReportingFiltersProvider } from '../../providers/ReportingFiltersProvider';
import { getHasUserScope } from '../../utils/userInfoUtils';
import useReportingContentIds from '../../hooks/useReportingContentIds';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentRevenueAttributionCard = ({
  variationId,
  variationIds
}) => {
  const {
    contentId,
    contentIds
  } = useReportingContentIds({
    variationId,
    variationIds
  });
  const {
    contentObjectType
  } = useContentObjectType();
  const {
    userInfo
  } = useAuthInfoProvider();
  const {
    dateRange
  } = useReportingFiltersProvider();
  const hasRevenueAttributionAccess = getHasUserScope(userInfo, 'revenue-attribution-read');
  const hasAttributionLiteAccess = getHasUserScope(userInfo, 'revenue-attribution-read');
  const hasVariationIds = contentIds && contentIds.length > 0;
  if (hasRevenueAttributionAccess || hasAttributionLiteAccess) {
    return /*#__PURE__*/_jsx(RevenueAttributionCard, {
      allowDrilldown: true,
      analyticsPageId: hasVariationIds ? null : contentId,
      analyticsPageIds: hasVariationIds ? List(contentIds) : List.of(),
      contentType: contentObjectType,
      dateRange: ImmutableMap(dateRange),
      hasRevenueAttributionAccess: hasRevenueAttributionAccess,
      useInlineLabels: false
    });
  }
  return null;
};
export default ContentRevenueAttributionCard;